module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAJFBMVEWrpJ25tLK7trK7uLXAkJPBkZTMzMzPFCvkoqrosbj87e7////LwTbBAAAAMElEQVQY02PYvXL1biDYXg4BDLvbulH4K4I8ViPzpxmYzUaRD4xYjU8/hvkQMFz4AJWHsVOT5BTLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mt.png
// module id = 883
// module chunks = 0